'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Select;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _ChevronsVertical = require('@deliveroo/icon-set/react/ChevronsVertical');

var _ChevronsVertical2 = _interopRequireDefault(_ChevronsVertical);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Label = require('../../internal/Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'wrapper': 'ccl-35e94f4f887a8736',
  'select': 'ccl-b5d86f97014f6b5c',
  'placeholder': 'ccl-57fcc45a43c675f2',
  'hiddenSelect': 'ccl-703b8463b9fc90ae',
  'invalid': 'ccl-ffd5404b60604563'
};
function Select(originalProps) {
  var _classnames;

  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, Select.placeholderProps) : originalProps;
  var id = props.id,
      selectedOptionText = props.selectedOptionText,
      _onChange = props.onChange,
      children = props.children,
      value = props.value,
      name = props.name,
      label = props.label,
      errorMessage = props.errorMessage,
      helpMessage = props.helpMessage,
      isRequired = props.isRequired,
      isInvalid = props.isInvalid,
      spacing = props.spacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing;


  var selectClassNames = (0, _classnames4.default)(styles.select, (_classnames = {}, _defineProperty(_classnames, styles.invalid, isInvalid), _defineProperty(_classnames, styles.placeholder, isPlaceholder), _classnames));

  var hiddenSelectClassNames = (0, _classnames4.default)(styles.hiddenSelect, _defineProperty({}, styles.placeholder, isPlaceholder));

  var getHelpMessage = function getHelpMessage() {
    if (typeof helpMessage === 'string') {
      return _react2.default.createElement(
        _P2.default,
        { size: 'x-small', color: 'grey', adjacentVerticalSpacing: 'small' },
        helpMessage
      );
    }

    return helpMessage;
  };

  var getErrorMessage = function getErrorMessage() {
    if (typeof errorMessage === 'string') {
      return _react2.default.createElement(
        _P2.default,
        { size: 'x-small', color: 'red', adjacentVerticalSpacing: 'small' },
        errorMessage
      );
    }

    return errorMessage;
  };

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'div',
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      className: styles.wrapper,
      isPlaceholder: isPlaceholder
    },
    label && _react2.default.createElement(
      _Label2.default,
      { 'for': id, spacing: '0 0 small' },
      label
    ),
    _react2.default.createElement(
      'select',
      {
        id: id,
        className: hiddenSelectClassNames,
        value: value,
        onChange: function onChange(e) {
          return _onChange(e.target.value);
        },
        name: name,
        required: isRequired
      },
      children
    ),
    _react2.default.createElement(
      'label',
      { className: selectClassNames, htmlFor: id },
      selectedOptionText,
      !isPlaceholder && _react2.default.createElement(_Icon2.default, { component: _ChevronsVertical2.default, size: 18, color: 'light-grey', spacing: '0 0 0 medium' })
    ),
    isInvalid && getErrorMessage(),
    !isInvalid && helpMessage && getHelpMessage()
  );
}

Select.displayName = 'Select';
Select.propTypes = _extends({
  /**
   * The id of the input this select represents
   */
  id: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * The name of the input this select represents
   */
  name: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * A label describing the Select.
   */
  label: _propTypes2.default.string,

  /**
   * An error message to display to indicate the Select has an invalid value.
   * Required if the select is invalid.
   */
  errorMessage: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]), function (props) {
    return props.inValid;
  }),

  /**
   * An optional help message to display underneath the Select.
   */
  helpMessage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /**
   * The current selected option text displayed in the faux select.
   */
  selectedOptionText: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * An array of `<option>` tags to be placed inside the select
   */
  children: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.arrayOf(_propTypes2.default.node), function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * Callback for when a new option is selected
   */
  onChange: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * If the select is required or not, for browser based validation
   */
  isRequired: _propTypes2.default.bool,

  /**
   * If the select is in an invalid state
   */
  isInvalid: _propTypes2.default.bool,

  /**
   * Current value of the select box
   */
  value: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), function (props) {
    return !props.isPlaceholder;
  })

}, _SpacerElement2.default.propTypes);

Select.defaultProps = {
  id: undefined,
  name: undefined,
  selectedOptionText: undefined,
  children: undefined,
  onChange: undefined,
  value: undefined,
  isRequired: false,
  isInvalid: false,
  label: undefined,
  errorMessage: undefined,
  helpMessage: undefined
};

Select.placeholderProps = {
  id: 'placeholder',
  name: 'placeholder',
  children: _react2.default.createElement(
    'option',
    null,
    'placeholder'
  ),
  selectedOptionText: 'placeholder'
};